import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import SessionController from "../../shared/session";
import Loading from "../../shared/loading";
import RouterService from "../../shared/services/router.service";
import Contact_Support_team from "../auth/contact_support_team";
import { SUPPORT_LINK } from "../../shared/constants/constants";
import AuthLogo from "../../shared/components/component_logo";

let loading = true;
let casError = null;
let sessionEnv = () => SessionController.session.environment;
let sessionEnvReady = () => SessionController.session && SessionController.session.environment;

function verifyToken(ticket, courseId) {
    let path = !!courseId ? `path=public/courses/${courseId}&` : '';
    let serviceUrl = `login/cas?${path}ticket=` + ticket;
    Requester.post(Gateway.identity + serviceUrl,
        {
            "ticket": ticket
        },
        {"Content-Type": "application/json"})
        .then(function (result) {
            SessionController.setSession(result);
            localStorage.setItem("sso-logout", result.identity.ssoLogout);
            if(!!courseId) {
                RouterService.navigateToPublicCourse(courseId);
            } else {
                RouterService.navigateOnLogin();
            }
        })
        .catch(function (error) {
            loading = false;
            const errorCode = error.response && error.response.properties && error.response.properties.errorCode;
            const supportedErrorCodes = ["SharedUserMergedToOtherProfile", "SharedUserEmailLinkedToOtherProfile"];
            if (supportedErrorCodes.includes(errorCode)) {
                casError = errorCode;
                m.redraw();
                return;
            }
            if (errorCode) {
                casError = "unable_to_log_in";
                m.redraw();
                return;
            }
            SessionController.getSession().then(session => {
                if(!!session.environment.logoutUrl) {
                    // If SSO login was successful any further attempts to login will automatically sign in,
                    // Visit the LogoutUrl to invalidate the session and redirect to the home page.
                    window.location = session.environment.logoutUrl + "?service=" + window.location.protocol + "//" + window.location.host;
                }
            })
            Toasts.error(JSON.stringify(error.response));
        });
}


const PublicPage_Login_SSO_CAS = {
    onremove: function () {
        casError = null;
    },
    oninit: function (vnode) {
        if (SessionController.session && SessionController.session.identity) {
            if(!!vnode.attrs.courseId) {
                RouterService.navigateToPublicCourse(vnode.attrs.courseId);
            }
            else {
                RouterService.navigateOnLogin();
                Toasts.add("success", i18n.t("already_logged_in"), "");
            }
            return;
        }

        if (m.route.param("ticket")) {
            verifyToken(m.route.param("ticket"), vnode.attrs.courseId);
        } else {
            RouterService.navigateToPublicLogin();
        }

    },
    view: function () {
        return [
            m(".splash-container", [
                loading ? m(Loading, {class: "loading-inline"})
                    : [
                        casError ? [
                            m(AuthLogo),
                            sessionEnvReady() && sessionEnv().about ? [
                                m("div.company-tagline", sessionEnv().about),
                            ] : "",
                            m(".mt-2.pt-2.text-center", [
                            m("i.icon-info.text-danger.icon-big", {style: ""}),
                            i18n.tWithNodes(casError, {
                                contact_our_support_team_link: m("a.hyperlink", {target: "_blank", href: SUPPORT_LINK}, i18n.t("contact_our_support_team"))
                            })
                        ])] : [
                            m("h3.mb-2", i18n.t("unable_to_log_in")),
                            m(".mb-2.pb-2", i18n.t("please_try_again_or_contact_support")),
                            SessionController.session && SessionController.session.environment && !SessionController.session.environment.ssoOnly ? [
                                m(m.route.Link, {href: RouterService.getPublicLoginUrl(), class: "btn"}, i18n.t("back_to_login"))
                            ] : "",
                        ],
                        casError ? m(Contact_Support_team) : null
                    ]
            ])
        ];
    }
};
export default PublicPage_Login_SSO_CAS;
